module.exports = __webpack_public_path__ + "static/media/maf-23.09bb79c9.png";